export const genderOptions = [
  { key: 'MALE', value: 'MALE' },
  { key: 'FEMALE', value: 'FEMALE' },
  { key: 'OTHERS', value: 'OTHERS' },
]

export const addressProofOptions = [
  { key: 'AADHAAR Card', value: 'AADHAAR' },
 // { key: 'Passport', value: 'Passport' },
 // { key: 'Driving License', value: 'DrivingLicense' },

]

export const specialtyOptions = [
  { key: "Family Physician", value: "Family Physician" },
  { key: "Infectious Disease", value: "Infectious Disease" },
  { key: "Paediatrics", value: "Paediatrics" },
  { key: "General Physician/ Internal Medicine", value: "General Physician/ Internal Medicine" },
  { key: "Gastroenterology/ GI Medicine", value: "Gastroenterology/ GI Medicine" },
  { key: "Obstetrics & Gynaecology", value: "Obstetrics & Gynaecology" },
  { key: "Endocrinology", value: "Endocrinology" },
  { key: "ENT", value: "ENT" }, { key: "Orthopaedics", value: "Orthopaedics" },
  { key: "Dermatology", value: "Dermatology" },
  { key: "Cardiology", value: "Cardiology" },
  { key: "Neurology", value: "Neurology" },
  { key: "Oncology", value: "Oncology" },
  { key: "Urology", value: "Urology" },
  { key: "Pulmonology/ Respiratory Medicine", value: "Pulmonology/ Respiratory Medicine" },
  { key: "Nephrology", value: "Nephrology" },
  { key: "Podiatry", value: "Podiatry" },
  { key: "Bariatrics", value: "Bariatrics" },
  { key: "Rheumatology", value: "Rheumatology" },
  { key: "General Surgery", value: "General Surgery" },
  { key: "Neurosurgery", value: "Neurosurgery" },
  { key: "CTVS", value: "CTVS" },
  { key: "Plastic Surgery", value: "Plastic Surgery" },
  { key: "Vascular Surgery", value: "Vascular Surgery" },
  { key: "Surgical Gastroenterology", value: "Surgical Gastroenterology" },
  { key: "Psychology", value: "Psychology" },
  { key: "Psychiatry", value: "Psychiatry" },
  { key: "Dietetics", value: "Dietetics" },
  { key: "Colorectal Surgery", value: "Colorectal Surgery" },
  { key: "Diabetology", value: "Diabetology" },
  { key: "Endocrine Surgery", value: "Endocrine Surgery" },
  { key: "General & Laparoscopic Surgeon", value: "General & Laparoscopic Surgeon" },
  { key: "Haematology", value: "Haematology" },
  { key: "Head & Neck Surgical Oncology", value: "Head & Neck Surgical Oncology" },
  { key: "Hepatology", value: "Hepatology" },
  { key: "Liver Transplant", value: "Liver Transplant" },
  { key: "Medical Oncology", value: "Medical Oncology" },
  { key: "Oral & Maxilofacial Surgery", value: "Oral & Maxilofacial Surgery" },
  { key: "Pain Management", value: "Pain Management" },
  { key: "Pediatric Cardiac Surgery", value: "Pediatric Cardiac Surgery" },
  { key: "Pediatric Gastroenterology", value: "Pediatric Gastroenterology" },
  { key: "Pediatric Neonatology", value: "Pediatric Neonatology" },
  { key: "Pediatric Nephrology", value: "Pediatric Nephrology" },
  { key: "Pediatric Neurology", value: "Pediatric Neurology" },
  { key: "Pediatric Surgery", value: "Pediatric Surgery" },
  { key: "Peripheral Vascular Surgery", value: "Peripheral Vascular Surgery" },
  { key: "Radiation Oncology", value: "Radiation Oncology" },
  { key: "Radiology", value: "Radiology" },
  { key: "Surgical Oncology", value: "Surgical Oncology" },
  { key: "Transplant Surgery", value: "Transplant Surgery" },
  { key: "Urogynaecology", value: "Urogynaecology" },
  { key: "Vascular & Endovascular Surgery", value: "Vascular & Endovascular Surgery" },
  { key: "Pediatric Opthalmology", value: "Pediatric Opthalmology" },
  { key: "Pediatric Pulmonology", value: "Pediatric Pulmonology" },
  { key: "Spine Surgery", value: "Spine Surgery" },
  { key: "Pediatric Cardiology", value: "Pediatric Cardiology" },
  { key: "Interventional Radiology", value: "Interventional Radiology" },
  { key: "Critical Care", value: "Critical Care" },
  { key: "Physiotherapy", value: "Physiotherapy" },
  { key: "Infertility", value: "Infertility" },
  { key: "Endodontics", value: "Endodontics" },
  { key: "Periodontics", value: "Periodontics" },
  { key: "Prosthodontics", value: "Prosthodontics" },
  { key: "Dentist", value: "Dentist" },
  { key: "Andrologist & InFertility", value: "Andrologist & InFertility" },
  { key: "Child Development", value: "Child Development" },
  { key: "Maxillofacial Surgery", value: "Maxillofacial Surgery" },
  { key: "Ophthalmology", value: "Ophthalmology" },
  { key: "Pediatric Ophthalmology", value: "Pediatric Ophthalmology" },
  { key: "Physical Medicine & Rehabilitation", value: "Physical Medicine & Rehabilitation" },
  { key: "Fetal Medicine", value: "Fetal Medicine" },
  { key: "Geriatrics", value: "Geriatrics" }
]

export const languageOptions = [
  {
    "key": "English",
    "value": "English"
  },
  {
    "key": "Assamese",
    "value": "Assamese"
  },
  {
    "key": "Bengali",
    "value": "Bengali"
  },
  {
    "key": "Bodo",
    "value": "Bodo"
  },
  {
    "key": "Dogri",
    "value": "Dogri"
  },
  {
    "key": "Gujarati",
    "value": "Gujarati"
  },
  {
    "key": "Hindi",
    "value": "Hindi"
  },
  {
    "key": "Kannada",
    "value": "Kannada"
  },
  {
    "key": "Kashmiri",
    "value": "Kashmiri"
  },
  {
    "key": "Konkani",
    "value": "Konkani"
  },
  {
    "key": "Maithili",
    "value": "Maithili"
  },
  {
    "key": "Malayalam",
    "value": "Malayalam"
  },
  {
    "key": "Manipuri",
    "value": "Manipuri"
  },
  {
    "key": "Marathi",
    "value": "Marathi"
  },
  {
    "key": "Nepali",
    "value": "Nepali"
  },
  {
    "key": "Oriya",
    "value": "Oriya"
  },
  {
    "key": "Punjabi",
    "value": "Punjabi"
  },
  {
    "key": "Sanskrit",
    "value": "Sanskrit"
  },
  {
    "key": "Santhali",
    "value": "Santhali"
  },
  {
    "key": "Sindhi",
    "value": "Sindhi"
  },
  {
    "key": "Tamil",
    "value": "Tamil"
  },
  {
    "key": "Telugu",
    "value": "Telugu"
  },
  {
    "key": "Urdu",
    "value": "Urdu"
  }
]

export const consultTypeOptions = [
  { key: 'ONLINE', value: 'ONLINE' },
  { key: 'PHYSICAL', value: 'PHYSICAL' },
  { key: 'BOTH', value: 'BOTH' }
]

export const termsAndConditionsOptions = [
  { key: 'Yes Agree', value: true }
]

export const weekOptions = [
  { key: 'ALL', value: 'ALL' },
  { key: 'MONDAY', value: 'MONDAY' },
  { key: 'TUESDAY', value: 'TUESDAY' },
  { key: 'WEDNESDAY', value: 'WEDNESDAY' },
  { key: 'THURSDAY', value: 'THURSDAY' },
  { key: 'FRIDAY', value: 'FRIDAY' },
  { key: 'SATURDAY', value: 'SATURDAY' },
  { key: 'SUNDAY', value: 'SUNDAY' }
]

export const loginRoleOptions = [
  { key: 'Doctor Executive', value: 'salesexecutive' },
  { key: 'Regional Manager', value: 'regionalsaleshead' },
  { key: 'Admin', value: 'admin' },
]
// export const roleOptions = (user) => user.role === 'admin' ? admin
export const slots = [
  'None',
  '8AM to 9AM',
  '9AM to 10AM',
  '10AM to 11AM',
  '11AM to 12PM',
  '12PM to 1PM',
  '1PM to 2PM',
  '2PM to 3PM',
  '3PM to 4PM',
  '4PM to 5PM',
  '5PM to 6PM',
  '6PM to 7PM',
  '7PM to 8PM',
  '8PM to 9PM',
  '9PM to 10PM',
  '10PM to 11PM'
]

export const countryOptions = [
  { key: 'India', value: 'India' }
]

export const statusOptions = [
  { key: 'Approve', value: 'approved' },
  { key: 'Reject', value: 'rejected' }
]

export const validateName = fullName => {
  if (fullName) {
    const passesApostropheConditions =
      !fullName.startsWith("'") &&
      !fullName.endsWith("'") &&
      !fullName.includes("''");

    return (
      /^[A-Z. ]*$/.test(fullName.trim()) &&
      fullName.trim().length >= 1 &&
      passesApostropheConditions
    );
  } else {
    return false
  }
};

export const validateCollege = collegeName => {
  // Regular expression pattern for validating the College Name with only letters and spaces
  const collegeNamePattern = /^[A-Za-z ]*$/;

  return collegeNamePattern.test(collegeName.trim());
};


export const validatePan = fullName => {
  if (fullName) {
    const passesApostropheConditions =
      !fullName.startsWith("'") &&
      !fullName.endsWith("'") &&
      !fullName.includes("''");

    return (
      /^[A-Z0-9]*$/.test(fullName.trim()) &&
      fullName.trim().length >= 1 &&
      passesApostropheConditions && fullName.trim().length === 10
    );
  } else {
    return false
  }
};

export const validateMobile = userPhone => {
  if (userPhone) {
    const mobilePattern = /^[0]?[6789]\d{9}$/;
    if (userPhone.length !==  10) return false
    if (mobilePattern.test(userPhone)) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const validateEmail = email => {
  if (email) {
    const emailPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (emailPattern.test(email)) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

export function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  return JSON.parse(jsonPayload);
}

export const stateOptions = new Array('Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Delhi', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jammu and Kashmir', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'WestBengal', 'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra and Nagar Haveli', 'Daman and Diu', 'Lakshadweep', 'Puducherry')

export const errorMessages = Object.freeze({
  email: 'This is not a valid Email Address',
  firstName: 'Full Name must be greater than one character and contains only UPPERCASE alphabets and space',
  middleName: 'Middle Name must be greater than one character and contains only UPPERCASE alphabets and space',
  lastName: 'Last Name must be greater than one character and contains only UPPERCASE alphabets and space',
  phone: `Phone Number must be less than 10 characters, special characters and spaces are not allowed`,
  displayName: 'Display Name must be greater than one character and contains only UPPERCASE alphabets and space',
  panNumber: `Only Uppercase Allowed, Should be Equal to 10 characters`,
  graduation_year:`Please Enter Grad Year`
})